<template>
  <div class="home">
    <div class="search">
      <div>
        <h1 v-html="'TALLERES PATRIMONIALES EN TORNO A PUERTO CRISTAL'"></h1>
      </div>
      <h4 v-html="'Fondo del Patromonio Cultural'"></h4>
    </div>
    <div class="section color1 split left">
      <div class="full-height"><div class="image" :style="{'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2F2025_Talleres.jpg?alt=media&token=d433a142-e4c3-46f7-b0d9-2bebc1cdc6bb)'}"></div></div>
      <div>
        <div class="content">
          <p v-html="'Esta iniciativa ha sido ejecutada gracias al financiamiento del Fondo Nacional del Patrimonio Cultural - FONPAT, del Servicio Nacional del Patrimonio.'"></p>
          <p v-html="'El objetivo principal del proyecto fue promover la identificaci&oacute;n, reconocimiento y valorizaci&oacute;n del patrimonio cultural asociado a Puerto Cristal en la comunidad de Ays&eacute;n, especialmente entre j&oacute;venes estudiantes, para fomentar la preservaci&oacute;n del patrimonio cultural. En esta instancia se ha beneficiado a 22 alumnos del Liceo Bicentenario Rural de Cerro Castillo y 15 estudiantes la Escuela Jos&eacute; Antol&iacute;n Silva Orme&ntilde;o de Balmaceda.'"></p>
<p v-html="'Para facilitar el aprendizaje dise&ntilde;&oacute; material did&aacute;ctico como un cuadernillo de campo con mapa y espacio para notas, un dossier con la historia resumida y descripci&oacute;n de Puerto Cristal, un plano general impreso en PVC. '"></p>
<p v-html="'En septiembre de 2025 se visit&oacute; a los establecimientos educacionales beneficiarios para entregar materiales, explicar la log&iacute;stica y resolver dudas. En el Liceo de Cerro Castillo los estudiantes ya hab&iacute;an iniciado su investigaci&oacute;n sobre Puerto Cristal porque realizar&iacute;an una actividad pr&aacute;ctica de guiado por el Campamento Minero. En la Escuela de Balmaceda se trabaj&oacute; con apoderados para informar sobre el proyecto y preparar el terreno.'"></p>
</div>
      </div>
    </div>
    
    <div class="section color4 split right">
      <div class="full">
        <div class="content img">
          <h1>Talleres Patrimoniales</h1>
          <p v-html="'En octubre de 2025 se realizaron los talleres presenciales en Puerto Cristal con los grupos de estudiantes y profesores a cargo. Con el Liceo Bicentenario Rural de Cerro Castillo realiz&oacute; trabaj&oacute; con la carrera de Turismo, por lo que, los estudiantes tuvieron la oportunidad visitar y realizar un guiado por los distintos hitos patrimoniales del Campamento Minero, tales como la Casa de Hu&eacute;spedes, iglesias, planta hidroel&eacute;ctrica, casino de empleados, escuela, bodegas portuarias, entre otros. Adicionalmente, organizaron actividades recreativas para mantener el inter&eacute;s de los participantes.'"></p>
<p v-html="'Por su parte, la Escuela Jos&eacute; Antol&iacute;n Silva Orme&ntilde;o no pudo llegar a Puerto Cristal debido al mal tiempo y cortes de rutas, producto de un frente de mal tiempo que afront&oacute; la Regi&oacute;n de Ays&eacute;n. En cambio, realizaron actividades en Puerto Tranquilo que les permitieron reflexionar sobre el aislamiento y las dificultades del poblamiento regional, visitaron la escuela local y la radio, y realizaron actividades art&iacute;sticas y recreativas en la nieve.'"></p>
<p v-html="'Tambi&eacute;n se prepar&oacute; un video documental para mostrar y dar a conocer el trabajo realizado'"></p>
<video autoplay muted loop controls="" class="right">
          <source
            src="https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCORTO.mp4?alt=media&token=41fdc81c-43fd-4af7-9b94-fb923ee56a84"
            type="video/mp4"
          />
        </video>
        
          <h1>Conversatorio</h1>
          <p v-html="'Como actividad de cierre del proyecto, el 18 de noviembre de 2025 se realiz&oacute; un conversatorio en el Auditorio del Museo Regional de Ays&eacute;n, con la participaci&oacute;n de estudiantes, docentes, expositores y la comunidad. Se presentaron exposiciones sobre el museo, la labor de la Agrupaci&oacute;n Social y Cultural Los Cristalinos, las experiencias de los estudiantes y se present&oacute; un video documental de las actividades realizadas durante el proyecto. En esta instancia los estudiantes tuvieron la oportunidad de presentar y mostrar su experiencia durante el terreno, adicionalmente, se trataron temas como la gesti&oacute;n de museos en territorios aislados y se realiz&oacute; un taller educativo con documentos hist&oacute;ricos y una visita guiada al museo y su dep&oacute;sito.'"></p>


        </div>
      </div>
    </div>
        
    <div class="section">
          <h1 v-html="'Fotograf&iacute;as'"></h1>
          <div class="gallery">
            <div
              class="item"
              v-for="(item, index) in images"
              :key="index"
              :style="'background-image:url(' + item.url + ')'"
            >
              <div class="hover" @click="openGallery(index)">
                <div>
                  <i class="material-icons">fullscreen</i>
                  <h5>{{ item.name }}</h5>
                </div>
              </div>
            </div>
        
      </div>
    </div>
    <Loading text="cargando" />
    <Message />
    <Gallery/>
  </div>
</template>
<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Message from "@/components/Message.vue";

import Gallery from "@/components/Gallery.vue";

import { mapMutations } from "vuex";
export default {
  name: "Home-page",
  components: {
    Loading,
    Message,
    Gallery
  },
  data: function () {
    return {
      col: [
        {
          link: "https://memoriaaustral.cl/",
          imagen: "../../../assets/media/puerto_cristal/MINA.JPG",
          title: "Mina",
          content:
            "Corporaci&oacute;n Cultural Memoria Austral nace en el a&ntilde;o 2013, como corporaci&oacute;n sin fines de lucro, con el objetivo de velar por el rescate y conservaci&oacute;n de la memoria de Ays&eacute;n, desde todos los &aacute;mbitos del patrimonio, favoreciendo la salvaguarda de la identidad regional.",
        },
        {
          link: "https://www.museoregionalaysen.gob.cl/",
          imagen: "../../assets/media/puerto_cristal/LABORATORIO.JPG",
          title: "Laboratorio",
          content:
            "El Museo Regional de Ays&eacute;n es una instituci&oacute;n perteneciente al Servicio Nacional del Patrimonio Cultural. Su apertura a la comunidad se produjo el a&ntilde;o 2018, luego de un largo trabajo de restauraci&oacute;n y habilitaci&oacute;n del Monumento Hist&oacute;rico Construcciones de la Sociedad Industrial de Ays&eacute;n y la construcci&oacute;n de un moderno edificio que alberga la Exposici&oacute;n Permanente Regional, Dep&oacute;sito de Colecciones, Auditorio y Oficinas de Trabajo.",
        },
        {
          link: "https://web.facebook.com/groups/310271558203",
          imagen:
            "https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Flogo_cristalinos.jpg?alt=media&token=e1e5fb66-43fb-4e98-8ddb-2717b54878f2",
          title: "Agrupaci&oacute;n Social y Cultural Los Cristalinos",
          content:
            "La Agrupaci&oacute;n Social y Cultural Los Cristalinos es una instituci&oacute;n que congrega a los antiguos habitantes del Campamento Minero Puerto Cristal, y que con su actuar, busca mantener viva su historia e identidad ligada a este Monumento Nacional.",
        },
      ],
      images: [{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FAULA_1.jpeg?alt=media&token=453b3cea-5963-485a-9196-bed11adcf0db',name:'Visita al Aula',position:0,view:0},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FAULA_2.jpeg?alt=media&token=30834666-18fe-4068-8649-c377a99c38fb',name:'Visita al Aula',position:1,view:1},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FAULA_3.jpeg?alt=media&token=dedd2e54-4002-4517-8f52-ce354985d93d',name:'Visita al Aula',position:2,view:2},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FAULA_4.jpeg?alt=media&token=4b64dc28-38ff-4f5f-86f6-ea8e14e07e77',name:'Visita al Aula',position:3,view:3},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_1.jpg?alt=media&token=93f5c20d-77b1-4325-8e7c-f8ff533a8542',name:'Liceo de Cerro Castillo en Terreno',position:4,view:4},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_2.jpg?alt=media&token=bbbfe9e8-3d8a-42f9-a889-84288c2d62c5',name:'Liceo de Cerro Castillo en Terreno',position:5,view:5},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_3.jpg?alt=media&token=0b8ff593-d733-4253-8622-fa1358be61d1',name:'Liceo de Cerro Castillo en Terreno',position:6,view:6},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_4.jpg?alt=media&token=a3bde431-8dd1-448b-943f-cf51441cc77f',name:'Liceo de Cerro Castillo en Terreno',position:7,view:7},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_5.jpg?alt=media&token=a4a4a7e8-627b-43df-bb82-529bf77c83de',name:'Liceo de Cerro Castillo en Terreno',position:8,view:8},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_6.jpg?alt=media&token=6128aef5-1ffc-46d3-b124-dbcea8c83a2a',name:'Liceo de Cerro Castillo en Terreno',position:9,view:9},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_7.jpg?alt=media&token=52a4d854-9d72-4699-8eaa-df7e2ff4c898',name:'Liceo de Cerro Castillo en Terreno',position:10,view:10},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_LBRCC_8.jpg?alt=media&token=32a30df7-abe9-427c-9e42-a8b72aa0855d',name:'Liceo de Cerro Castillo en Terreno',position:11,view:11},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_1.jpeg?alt=media&token=544324d7-efea-4c5f-b11b-cb91c1117b0d',name:'Escuela de Balmaceda en Terreno',position:12,view:12},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_2.jpeg?alt=media&token=338a5c1f-40b5-433d-a494-240af2c6df92',name:'Escuela de Balmaceda en Terreno',position:13,view:13},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_3.jpeg?alt=media&token=d828a986-998c-42a9-86c5-710d1632eb41',name:'Escuela de Balmaceda en Terreno',position:14,view:14},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_4.jpeg?alt=media&token=5e3a1516-349a-4c75-8405-24d29af0097c',name:'Escuela de Balmaceda en Terreno',position:15,view:15},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_5.jpeg?alt=media&token=65cb6743-adc8-407c-84b7-c31e30d03067',name:'Escuela de Balmaceda en Terreno',position:16,view:16},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FTERRENO_EJASO_6.jpeg?alt=media&token=76ee3200-b858-4122-a682-54e0c1ea3836',name:'Escuela de Balmaceda en Terreno',position:17,view:17},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_1.jpg?alt=media&token=7d931868-2033-4a70-b9c5-10c8e49a58ae',name:'Conversatorio Patrimonial',position:18,view:18},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_2.jpg?alt=media&token=beffce94-160f-475f-a81e-d093a9b1f39a',name:'Conversatorio Patrimonial',position:19,view:19},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_3.jpg?alt=media&token=be7b687b-c66e-40f2-82a2-8f41cf155493',name:'Conversatorio Patrimonial',position:20,view:20},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_4.jpg?alt=media&token=feabd6c7-d3df-4c4b-9fdb-780d232ae7c0',name:'Conversatorio Patrimonial',position:21,view:21},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_5.jpg?alt=media&token=63339102-bbba-4b8c-a811-91636effc525',name:'Conversatorio Patrimonial',position:22,view:22},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_6.jpg?alt=media&token=ff4b50d9-d37e-4153-b348-3d0ff4f2d131',name:'Conversatorio Patrimonial',position:23,view:23},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_7.jpg?alt=media&token=14be9c7f-cc13-4f24-864d-53db30a7e706',name:'Conversatorio Patrimonial',position:24,view:24},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_8.jpg?alt=media&token=f50e7ad1-a2af-4407-bf5d-ebe19044f182',name:'Conversatorio Patrimonial',position:25,view:25},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_9.jpg?alt=media&token=9b05fd31-b8bf-4fd8-9969-8fab2065373a',name:'Conversatorio Patrimonial',position:26,view:26},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_10.jpg?alt=media&token=1ac45b54-f5a8-40dd-a332-11f1f48797b6',name:'Conversatorio Patrimonial',position:27,view:27},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_11.jpg?alt=media&token=4b9ed33f-f11a-4dd6-b4b9-e09f7c7000bb',name:'Conversatorio Patrimonial',position:28,view:28},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_12.jpg?alt=media&token=4b6e3442-be27-4ac1-981f-6f35a9b7c194',name:'Conversatorio Patrimonial',position:29,view:29},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_13.jpg?alt=media&token=a1fca8bc-528c-49e3-9695-f9bdd231e032',name:'Conversatorio Patrimonial',position:30,view:30},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_14.jpg?alt=media&token=634f6360-f619-4cb8-a07e-b9845e47a32b',name:'Conversatorio Patrimonial',position:31,view:31},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_15.jpg?alt=media&token=0d16f685-3ccb-42ff-b8b2-d625e906d054',name:'Conversatorio Patrimonial',position:32,view:32},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_16.jpg?alt=media&token=5a2d315d-0a1c-4c8b-88a1-2eb50e15f2ff',name:'Conversatorio Patrimonial',position:33,view:33},
{url:'https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FCONVERSATORIO_17.jpg?alt=media&token=c8798e4c-8394-4a64-8920-5a82b6b5a87e',name:'Conversatorio Patrimonial',position:34,view:34},
],
    };
  },
  created() {
    this.SET_LOADING(false);
  },
  methods: {
    ...mapMutations([
      "SET_LOADING",
      "SET_GALLERY",
      "SET_GALLERY_INDEX",
      "SET_GALLERY_ITEMS",
      "SET_GALLERY_TYPE",
    ]),
    openGallery(payload) {
      let pos = this.images.findIndex((item) => item.position === payload);
      let el = this.images[pos];
      let arr = this.images;
      arr.splice(pos, 1);
      arr.splice(0, 0, el);
      this.SET_GALLERY_ITEMS(arr);
      this.SET_GALLERY_INDEX(payload);
      this.SET_GALLERY_TYPE("COLECCION");
      this.SET_GALLERY(true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables";
@import "../../assets/sass/buttons";
@import "../../assets/sass/cards";

.home {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 70vh auto;
  width: 100vw;
  
  div.autocomplete-container {
    padding: 25px 13em 45px 3em;
    div {
      display: grid;
      grid-template-columns: auto 60px;
      grid-template-rows: 50px;
      border-radius: 50px;
      background-color: white;
      padding: 0px;
      overflow: visible;
      .radius-left {
        border-bottom-left-radius: 50px;
        border-top-left-radius: 50px;
      }
      .radius-right {
        border-top-right-radius: 50px;
        border-bottom-right-radius: 50px;
      }

      button {
        margin-block-end: 0px;
        margin-block-start: 0px;
        background-color: $theme;
        border: none;
        cursor: pointer;
        i.material-icons {
          vertical-align: middle;
          font-size: 35px;
          color: white;
        }
      }
      button:disabled {
        opacity: 0.5;
        cursor: no-drop;
      }
    }
  }
  .search {
    background-image: linear-gradient(
        to bottom,
        transparent,
        rgba(0, 0, 0, 0.75)
      ),
      url("https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2Fproyectos%2F2025_Talleres%2FVISITA%20LICEO%20CERRO%20CASTILLO%20(4).jpeg?alt=media&token=80580a54-87ba-411a-bfce-2a76599207c3");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: grid;
    grid-template-rows: calc(100% - 220px) 50px 120px 50px;
    h1,
    h4 {
      position: relative;
      text-align: center;
      padding-left: 10%;
      padding-right: 10%;
      margin-block-end: 0px;
      margin-block-start: 0px;
    }
    div.search-options {
      align-content: center;
      input[type="radio"] {
        margin-block-start: 5px;
        margin-block-end: 5px;
        height: 20px;
        width: 20px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: middle;
      }
      label {
        color: white;
        display: inline-block;
        margin-right: 30px;
        margin-block-end: 0px;
        margin-block-start: 0px;
        vertical-align: middle;
        margin-top: 0px;
        line-height: 20px;
      }
    }
    div {
      padding-left: 10%;
      padding-right: 10%;
      position: relative;
      h1 {
        text-align: center;
        display: block;
        width: 100%;
        bottom: 0%;
        left: 50%;
        margin-bottom: 0px;
        position: absolute;
        transform: translateX(-50%);
      }
    }
    h1 {
      font-size: 3em;
      font-weight: 700;
      color: $theme-l4;
      vertical-align: text-bottom;
    }
    h4 {
      font-size: 2em;
      color: wheat;
    }
  }
  .section {
    position: relative;
    padding: 0.5em 2em;
    display: grid;
    grid-template-rows: auto;
    gap: 1em;
    
    h1 {
            font-size: 3em;
            font-weight: 700;
            margin-block-start: 0;
            margin-block-end: 0;
          }
          p {
            font-size: 1.1em;
            font-weight: 300;
            text-align: justify;
          }
    &.color1 {
      background-color: $blue-grey;
      h1,
      h2,
      h3,
      h4,
      h5 {
        color: $grey-2;
      }
      p,
      li {
        color: $grey-1;
      }
    }
    &.color2 {
      background-color: $grey-1;
      h1,
      h2,
      h3,
      h4,
      h5 {
        color: $theme-d1;
      }
      p,
      li {
        color: $theme-d3;
      }
    }

    &.color3 {
      background-color: $theme-l4;
      h1,
      h2,
      h3,
      h4,
      h5 {
        color: $theme-d2;
      }
      p,
      li {
        color: $blue-grey-dark;
      }
    }
    
    &.color4 {
      background-color: $grey-1;
      h1,
      h2,
      h3,
      h4,
      h5 {
        color: $text-dark;
      }
      p,
      li {
        color: $text-dark;
      }
    }
    &.split,
    &.full {
      height: 100%;
      div {
        &.full {
          grid-column-start: 1;
          grid-column-end: 3;
        }
        position: relative;
        height: 100% !important;
        display: block;
        .title,
        .content {
          width: 100%;
          display: block;
          height: fit-content;
          &.img {
            img.left {
              border-radius: 1em;
              width: 100%;
            }
            img.right {
              border-radius: 1em;
              width: 100%;
            }
            video.left {
              border-radius: 1em;
              width: 100%;
            }
            video.right {
              border-radius: 1em;
              width: 100%;
            }
          }
          &.multy {
            display: grid;
          }
          h1 {
            font-size: 3em;
            font-weight: 700;
            margin-block-start: 0;
            margin-block-end: 0;
          }
          p {
            font-size: 1.1em;
            font-weight: 300;
            text-align: justify;
          }
          
        }
        .image {
          border-radius: 1em;
          width: 100%;
          padding-top: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          &#img1 {
            background-image: url("https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2F1%20mina%2FLastScan%20TYUI.jpg?alt=media&token=a22f582f-788c-48b4-b1b2-4a826a056bd4&_gl=1*anfvst*_ga*NjAzNTQwNTkxLjE2ODU3MjcyNzM.*_ga_CW55HF8NVT*MTY4NTg0MDU5My41LjEuMTY4NTg0MDYwMS4wLjAuMA..");
          }
          &#img2 {
            background-image: url("https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2F1%20mina%2FMINA%20-40.jpg?alt=media&token=ade126b1-af45-4eb7-a212-3cf1e6d13b9f&_gl=1*lf7w9i*_ga*NjAzNTQwNTkxLjE2ODU3MjcyNzM.*_ga_CW55HF8NVT*MTY4NTkxNTczMy43LjEuMTY4NTkxNjU0OS4wLjAuMA..");
          }
          &#img3 {
            background-image: url("https://firebasestorage.googleapis.com/v0/b/colecciones-e9ef9.appspot.com/o/system%2Fmedia_pc%2F1%20mina%2FLastScan%20106.jpg?alt=media&token=996f6d57-a11f-48b8-a920-405597c273dd&_gl=1*1gbuw9u*_ga*NjAzNTQwNTkxLjE2ODU3MjcyNzM.*_ga_CW55HF8NVT*MTY4NTkxNTczMy43LjEuMTY4NTkxNjgwMC4wLjAuMA..");
          }
        }
      }
    }
    .gallery {
            display: grid;
            grid-gap: 0.8em;
            grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
            position: relative;
            padding-bottom: 2em;
            .item {
              padding-top: 100%;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              position: relative;
              border-radius: 5px;
              overflow: hidden;
              .hover {
                height: 100%;
                width: 100%;
                position: absolute;
                background-color: rgba($color: #000000, $alpha: 0.65);
                top: 0%;
                margin-top: 0%;
                opacity: 0;
                div {
                  width: 100%;
                  margin-top: calc(50% - 32px);
                  i.material-icons {
                    font-size: 35px;
                    color: whitesmoke;
                    text-align: center;
                    width: 100%;
                    vertical-align: middle;
                  }
                  h5 {
                    color: whitesmoke;
                    text-align: center;
                  }
                }
              }
              .hover:hover {
                cursor: pointer;
                opacity: 1;
              }
            }
          }
  }
}
@media (min-width: 768px) {
  .home {
    grid-template-rows: 75vh auto;
    .search {
      .video-container {
        video {
          min-height: 100%;
          min-width: 100%;
        }
      }
      .content {
        margin-left: 5em !important;
      }
    }
    .section {
      padding: 3em 5em;
      gap: 0.5em 2em;
      &.split {
        &.left {
          grid-template-columns: 1.5fr 2.5fr;
        }
        &.right {
          grid-template-columns: 2.5fr 1.5fr;
        }
        .content {
          &.img {
            img.left {
              border-radius: 1em;
              float: left;
              max-width: 40%;
              margin-right: 2em;
            }
            img.right {
              border-radius: 1em;
              float: right;
              max-width: 40%;
              margin-left: 2em;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 992px) {
  .home {
    grid-template-rows: 75vh auto;
    .search {
      .video-container {
        video {
          min-height: 100%;
          min-width: 100%;
        }
      }
      .content {
        margin-left: 11em !important;
      }
    }
    .section {
      padding: 3em 13em;
      &.split {
        &.left {
          grid-template-columns: 1.5fr 2.5fr;
        }
        &.right {
          grid-template-columns: 2.5fr 1.5fr;
        }
      }
    }
  }
}
</style>
